"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { useShouldUseDrawer } from "../../hooks/useShouldUseDrawer.js";
import { PopoverModeContext } from "./PopoverContext.js";
function PopoverRoot({ open, defaultOpen, onOpenChange, onOpenChangeComplete, modal, disablePointerDismissal, isDrawerModal = false, children }) {
    const useDrawer = useShouldUseDrawer();
    const mode = useDrawer ? 'drawer' : 'popover';
    return /*#__PURE__*/ jsx(PopoverModeContext.Provider, {
        value: mode,
        children: useDrawer ? /*#__PURE__*/ jsxs(Drawer.Root, {
            open: open,
            defaultOpen: defaultOpen,
            onOpenChange: onOpenChange,
            onOpenChangeComplete: onOpenChangeComplete,
            modal: isDrawerModal || (modal ?? false),
            disablePointerDismissal: disablePointerDismissal ?? false,
            children: [
                isDrawerModal && /*#__PURE__*/ jsx(Drawer.Backdrop, {
                    className: "fixed inset-0 z-[1] min-h-dvh bg-neutral-13/50 transition-opacity duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0"
                }),
                children
            ]
        }) : /*#__PURE__*/ jsx(Popover.Root, {
            open: open,
            defaultOpen: defaultOpen,
            onOpenChange: onOpenChange,
            onOpenChangeComplete: onOpenChangeComplete,
            modal: modal,
            children: children
        })
    });
}
export { PopoverRoot };
